import React, { PropsWithChildren } from 'react'
import { useTranslation } from 'react-i18next'
import { Card, Typography } from 'antd'
import bfaLogo from 'src/assets/images/bfa-logo.png'
import backgroundImage from 'src/assets/images/background-page.png'
import userImage from 'src/assets/images/user-01.png'
import { colorTextSubtlest } from 'src/app/themes/primaryThemeDefault'
import './logout.scss'

const InactiveUserPage: React.FC = (props: PropsWithChildren) => {
  const { t } = useTranslation()

  return (
    <div
      className='page-container'
      style={{
        backgroundImage: `url(${backgroundImage})`,
        backgroundSize: 'cover',
        backgroundRepeat: 'no-repeat',
        position: 'relative',
      }}
    >
      <img className='page-logo' src={bfaLogo} alt='logo' />
      <Card className='page-card' bordered={false}>
        <img src={userImage} alt='inactive-user-image' />
        <Typography.Title level={1} style={{ lineHeight: '38px', fontSize: '28px' }}>
          {t('common:inactive_user')}
        </Typography.Title>

        <Typography.Text type='secondary' style={{ textAlign: 'center', color: colorTextSubtlest }}>
          {t('common:inactive_user_message')}
        </Typography.Text>
      </Card>
    </div>
  )
}

export default InactiveUserPage
